/**
 * Traveler's Log: every system the pilot has charted — when it was found,
 * what burns at its center, and every world and moon in it. Reached from
 * the ESC menu; the discovery system will grow (landings, sites, firsts),
 * so rows render from data and nothing here assumes the schema is done.
 */
import { systemDefFor } from "@hyperlight/shared";

export class TravelLog {
  visible = false;
  private el: HTMLElement;

  constructor(private handlers: { onClose: () => void }) {
    this.el = document.createElement("div");
    this.el.id = "travel-log";
    this.el.style.display = "none";
    document.body.appendChild(this.el);
  }

  open(discovered: Map<string, number>, base: string, hereId: string): void {
    this.visible = true;
    this.el.style.display = "flex";

    const entries = [...discovered.entries()].sort((a, b) => b[1] - a[1]);
    let rows = "";
    for (const [id, at] of entries) {
      const def = systemDefFor(id); // C4: resolves home ids too (not charted today, future-proof)
      if (!def) continue;
      const when =
        at > 0
          ? new Date(at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
          : "—";
      const starHex = `#${def.star.color.toString(16).padStart(6, "0")}`;
      const planets = def.planets.filter((p) => !p.parentId);
      const bodies = planets
        .map((p) => {
          const moons = def.planets.filter((m) => m.parentId === p.id);
          const moonTxt = moons.length
            ? `<i class="tl-moons">${moons.map((m) => m.name.split(" ").pop()).join(" · ")}</i>`
            : "";
          return `<span class="tl-body tl-${p.archetype}" title="${p.archetype}${moons.length ? ` — moons: ${moons.map((m) => m.name).join(", ")}` : ""}">${p.name}${moonTxt}</span>`;
        })
        .join("");
      rows += `<div class="tl-row">
        <div class="tl-head">
          <span class="tl-star" style="background:${starHex};box-shadow:0 0 8px ${starHex}"></span>
          <b>${def.name}</b>
          <span class="tl-id">${id}</span>
          ${id === base ? '<span class="tl-tag tl-home">⌂ HOME BASE</span>' : ""}
          ${id === hereId ? '<span class="tl-tag tl-here">YOU ARE HERE</span>' : ""}
          <span class="tl-when">charted ${when}</span>
        </div>
        <div class="tl-bodies">${bodies}</div>
      </div>`;
    }

    this.el.innerHTML = `
      <div class="tl-panel">
        <div class="tl-title">TRAVELER'S LOG</div>
        <div class="tl-sub">${entries.length} system${entries.length === 1 ? "" : "s"} charted</div>
        <div class="tl-list">${rows || '<div class="tl-empty">Nothing charted yet — fly somewhere.</div>'}</div>
        <button class="tl-close" id="tl-close">BACK (esc)</button>
      </div>
    `;
    this.el.querySelector("#tl-close")!.addEventListener("click", () => this.close());
  }

  close(): void {
    if (!this.visible) return;
    this.visible = false;
    this.el.style.display = "none";
    this.handlers.onClose();
  }
}
